// Progress videos (admin/progress-videos) — migrated to the OpenAPI-generated client.
//
// The legacy functions returned the RAW axios response; consumers read `response.data.body`
// (the HttpResponse envelope's paged body) for the list, and treat the rest as fire-and-
// forget. The SDK's `data` == the old `response.data`, so each returns `{data}`. The list
// endpoint takes FLAT pageId/pageSize query params (not a nested Spring Pageable), so it is
// safe to serialize through the SDK. Auth + X-Timezone come from configureApi's interceptor.

import {
    adminProgressVideoControllerGetVideos,
    adminProgressVideoControllerAddVideo,
    adminProgressVideoControllerDeleteVideo,
    adminProgressVideoControllerDeleteVideosByDate,
    adminProgressVideoControllerSaveDateComment,
} from "../api/generated";

export async function getProgressVideos(traineeId, pageId, pageSize) {
    const {data, error} = await adminProgressVideoControllerGetVideos({
        path: {traineeId},
        query: {pageId, pageSize},
    });
    if (error) throw error;
    return {data};
}

export async function addProgressVideo(traineeId, videoUrl, videoDate) {
    const {data, error} = await adminProgressVideoControllerAddVideo({
        path: {traineeId},
        body: {videoUrl, videoDate},
    });
    if (error) throw error;
    return {data};
}

export async function deleteProgressVideo(traineeId, videoId) {
    const {data, error} = await adminProgressVideoControllerDeleteVideo({
        path: {traineeId, videoId},
    });
    if (error) throw error;
    return {data};
}

export async function deleteProgressVideosByDate(traineeId, videoDate) {
    const {data, error} = await adminProgressVideoControllerDeleteVideosByDate({
        path: {traineeId, videoDate},
    });
    if (error) throw error;
    return {data};
}

export async function saveVideoDateComment(traineeId, videoDate, comment) {
    const {data, error} = await adminProgressVideoControllerSaveDateComment({
        path: {traineeId},
        body: {videoDate, comment},
    });
    if (error) throw error;
    return {data};
}
